import { IconsProps } from './IconsProps';

const SummerVs = ({
  className = '',
  viewBox = '0 0 141.73 141.73',
  width = 40,
  height = 40,
  onClick,
  svgFill = 'currentColor',
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <g>
        <path d="M70.1,90.26c-10.69,0-19.39-8.7-19.39-19.39s8.7-19.39,19.39-19.39,19.39,8.7,19.39,19.39-8.7,19.39-19.39,19.39Z" />
        <g>
          <path d="M70.1,27.15c-1.49,0-2.7,1.21-2.7,2.7v13.16c0,1.49,1.21,2.7,2.7,2.7s2.7-1.21,2.7-2.7v-13.16c0-1.49-1.21-2.7-2.7-2.7Z" />
          <path d="M112.11,68.17h-13.17c-1.49,0-2.7,1.21-2.7,2.7s1.21,2.7,2.7,2.7h13.17c1.49,0,2.7-1.21,2.7-2.7s-1.21-2.7-2.7-2.7Z" />
          <path d="M90.84,53.19c.71,0,1.4-.29,1.91-.79l9.31-9.3c.51-.51,.79-1.19,.79-1.91s-.28-1.4-.79-1.9c-1.02-1.02-2.8-1.02-3.82,0l-9.31,9.3c-1.05,1.05-1.05,2.76,0,3.82,.51,.51,1.19,.79,1.91,.79Z" />
          <path d="M46.66,52.4c.51,.51,1.19,.79,1.91,.79s1.4-.28,1.91-.79c.51-.51,.79-1.19,.79-1.91s-.28-1.4-.79-1.91l-9.31-9.3c-1.02-1.02-2.8-1.02-3.82,0-.51,.51-.79,1.19-.79,1.91s.28,1.4,.79,1.91l9.31,9.3Z" />
          <path d="M48.45,89.08l-9.31,9.3c-.51,.51-.79,1.19-.79,1.91s.28,1.4,.79,1.91c.51,.51,1.19,.79,1.91,.79s1.4-.28,1.91-.79l9.31-9.3c.51-.51,.79-1.19,.79-1.91s-.28-1.4-.79-1.91c-1.02-1.02-2.8-1.02-3.82,0Z" />
          <path d="M92.75,89.08c-1.02-1.02-2.8-1.02-3.82,0-.51,.51-.79,1.19-.79,1.91s.28,1.4,.79,1.91l9.31,9.3c.5,.5,1.2,.79,1.91,.79s1.4-.28,1.91-.79c.51-.51,.79-1.19,.79-1.91s-.28-1.4-.79-1.91l-9.31-9.3Z" />
          <path d="M45.47,70.87c0-1.49-1.21-2.7-2.7-2.7h-13.15c-1.49,0-2.7,1.21-2.7,2.7s1.21,2.7,2.7,2.7h13.15c1.49,0,2.7-1.21,2.7-2.7Z" />
          <path d="M70.1,96.03c-1.49,0-2.7,1.21-2.7,2.7v13.16c0,1.49,1.21,2.7,2.7,2.7s2.7-1.21,2.7-2.7v-13.16c0-1.49-1.21-2.7-2.7-2.7Z" />
        </g>
      </g>
    </svg>
  );
};
export default SummerVs;
